import React, { useState, useEffect } from 'react';
import { Typography, Button, Modal, Tabs, Tab, Avatar, Box } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Timeline, Assessment, Settings } from '@material-ui/icons';
import { Workspaces } from '@mui/icons-material';
import PropTypes from 'prop-types';
import 'ag-grid-enterprise';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import clsx from 'clsx';
import store from '../../../redux/store';
import UngroupedListings from './UngroupedListings';
import SingleInteractiveGraph from './SingleInteractiveGraph';
import * as pricingActionsImport from '../../../redux/actions/pricing';
import {
  refreshInventory,
  setGroupsOpenned,
  setGroupFocused,
  refreshGroupedListings,
} from '../../../redux/actions/refresh-groups-inventory';
import TableauTab from './TableauTab';
import { refreshGroups } from '../../../redux/actions/refresh-groups';
import NewGroupModal from '../../../components/CreateGroupModal';
import Card from '../../../components/Common/Card';
import AutomationTab from './AutomationTab';
import { hasAutomationTabAccess } from '../../../helpers/user';

const TEN = 10;
const FIFTY = 50;
const EMPTY_STRING = '';
const ENTER_KEY_CODE = 13;
const TABS = {
  UNGROUPED: 'Ungrouped',
  HELD_OVER_TIME: 'Held Over Time',
  TABLEAU: 'Tableau',
  AUTOMATION: 'Automation',
};

const CreateGroupModal = styled.div`
  top: ${FIFTY}%;
  left: ${FIFTY}%;
  transform: translate(-${FIFTY}%, -${FIFTY}%);

  h2,
  h3 {
    margin-bottom: ${TEN}px;
  }
`;
const styles = makeStyles(theme => ({
  labelIcon: {
    height: '0.5em',
    width: '0.5em',
  },
  labelContainer: {
    padding: 0,
    width: 'auto',
    marginLeft: '4px',
  },
  tabRoot: {
    minHeight: 0,
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  labelWrapped: {
    flexDirection: 'row',
    padding: '3px',
  },
  label: {
    // left: '10px',
  },
  tabButton: {
    padding: 0,
    minHeight: 0,
  },
  hideDiv: {
    display: 'none',
  },
  inventoryTabsWrap: {
    height: '40vh',
    textAlign: 'center',
  },
  automationTabContainer: {
    overflowX: 'auto',
  },
  tableauTabsWrap: {
    minHeight: '50vh',
    textAlign: 'center',
  },
  contentHeight: {
    height: '40vh',
  },
  containersHeight: {
    height: '100%',
  },
  addButton: {
    position: 'absolute',
    zIndex: '1',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  pricingLoadingModalPaper: {
    position: 'absolute',
    width: theme.spacing(FIFTY),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
  },
  createGroupModalHeaderText: {
    '& span': {
      marginRight: '10px',
    },
  },
  createGroupButtonWrap: {
    marginTop: theme.spacing(2),
  },
  iconOnly: {
    marginRight: '10px',
  },
  tabLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tab: {
    color: '#A8A8A8',
    minHeight: '0px',
    minWidth: '0px',
    '&:hover': {
      '&.Mui-selected .MuiTab-wrapper .MuiAvatar-root': {
        backgroundColor: '#9C27B0 !important',
      },
      '&.MuiTab-root .MuiTab-wrapper .MuiAvatar-root': {
        backgroundColor: '#BEBEBE',
      },
      '&.MuiTab-root .MuiTab-wrapper': {
        color: '#BEBEBE',
      },
      '&.Mui-selected .MuiTab-wrapper': {
        color: '#9C27B0',
      },
    },
    '&.MuiTab-root .MuiTab-wrapper': {
      alignItems: 'center',
      flexDirection: 'row',
      padding: '3px',
      whiteSpace: 'nowrap',
    },
    '&.MuiTab-root .MuiTab-wrapper .MuiAvatar-root': {
      backgroundColor: '#A8A8A8',
      width: theme.spacing(3),
      height: theme.spacing(3),
      margin: '0px',
      marginRight: theme.spacing(1),
    },
    '&.Mui-selected .MuiTab-wrapper .MuiAvatar-root': {
      backgroundColor: '#9C27B0',
      width: theme.spacing(3),
      height: theme.spacing(3),
      margin: '0px',
      marginRight: theme.spacing(1),
    },
  },
  tabDark: {
    color: '#A8A8A8',
    minHeight: '0px',
    minWidth: '0px',
    '&:hover': {
      '&.Mui-selected .MuiTab-wrapper .MuiAvatar-root': {
        backgroundColor: '#BA68C8 !important',
      },
      '&.MuiTab-root .MuiTab-wrapper .MuiAvatar-root': {
        backgroundColor: '#BEBEBE',
      },
      '&.MuiTab-root .MuiTab-wrapper': {
        color: '#BEBEBE',
      },
      '&.Mui-selected .MuiTab-wrapper': {
        color: '#BA68C8',
      },
    },
    '&.MuiTab-root .MuiTab-wrapper': {
      alignItems: 'center',
      flexDirection: 'row',
      padding: '3px',
      whiteSpace: 'nowrap',
    },
    '&.MuiTab-root .MuiTab-wrapper .MuiAvatar-root': {
      backgroundColor: '#A8A8A8',
      width: theme.spacing(3),
      height: theme.spacing(3),
      margin: '0px',
      marginRight: theme.spacing(1),
    },
    '&.Mui-selected .MuiTab-wrapper .MuiAvatar-root': {
      backgroundColor: '#BA68C8',
      width: theme.spacing(3),
      height: theme.spacing(3),
      margin: '0px',
      marginRight: theme.spacing(1),
    },
    '&.Mui-selected .MuiTab-wrapper .MuiAvatar-colorDefault': {
      color: '#D4D4D4',
    },
    '&.Mui-selected .MuiTab-wrapper .divWrapper': {
      backgroundColor: '#D4D4D4',
    },
    '&.MuiTab-wrapper .divWrapper': {
      backgroundColor: '#212121',
    },
  },
}));

function Inventory(props) {
  const [state, setState] = useState({
    currGroupName: '',
    createGroupModalOpen: false,
    addListingsModalOpen: false,
    createGroupSaveButtonDisabled: true,
    openDial: false,
    direction: 'up',
    tabSelected: TABS.UNGROUPED,
    mountUngroupedListings: false,
    isLoading: false,
  });
  const classes = styles();
  const theme = useTheme();
  const showAutomationTab = hasAutomationTabAccess();

  const handleHitEnter = e => {
    if (e.target.name === 'groupName' && (e.key === 'Enter' || e.keyCode === ENTER_KEY_CODE)) {
      e.stopPropagation();
    }
  };

  const onSelectionChanged = selectedRows => {
    const { pricingActions } = props;
    pricingActions.toggleCreateGroupButton(!selectedRows || !selectedRows.length);
    pricingActions.inventoryRowsSelected(selectedRows);
  };

  const createGroupButtonClicked = () => {
    setState({
      ...state,
      createGroupModalOpen: true,
      currGroupName: '',
    });
  };

  // Note: this is called via string
  const addListingsButtonClicked = () => {
    setState({
      ...state,
      addListingsModalOpen: true,
    });
  };

  const createGroupNameInputChanged = event => {
    const newName = event.target.value;
    setState({
      ...state,
      createGroupSaveButtonDisabled: newName === EMPTY_STRING,
      currGroupName: newName,
    });
  };

  const createGroupSaveButtonClicked = async event => {
    event.preventDefault();

    try {
      setState({ ...state, createGroupSaveButtonDisabled: true, isLoading: true });
      const {
        pricingActions,
        selectedInventoryRows,
        currTNComparisonSections,
        typeListing,
        skyboxId,
        zones,
        groupsOpenned,
      } = props;
      const { currGroupName } = state;
      const costPerUnit = selectedInventoryRows[0].data.cost_per_unit;
      const isGreaterThanZero = costPerUnit > 0;
      const radix = 10;
      let floorPrice;

      if (isGreaterThanZero) {
        floorPrice = parseInt(costPerUnit * 1.1, radix);
        floorPrice += 0.99;
      } else {
        floorPrice = 20.99;
      }

      if (currGroupName && currGroupName !== '') {
        const groupData = [
          {
            skybox_event_id: skyboxId,
            ranks: selectedInventoryRows.map((row, index) => ({
              rank: index,
              skybox_listing_id: row.data.skybox_listing_id,
              unit_cost: row.data.unit_cost,
              include_exclude: [],
            })),
            exclude_obstructed_view: 1,
            name: currGroupName,
            ceiling: null,
            floor: floorPrice,
            increment: -0.5,
            increment_type: '%',
            spaceout: 5,
            spaceout_type: '%',
            splits: ['All'],
            auto_broadcast: 0,
          },
        ];

        const comps = {};
        comps.ticketnetwork = typeListing === 'ticketnetwork' ? currTNComparisonSections : [];
        comps.seatgeek = typeListing === 'seatgeek' ? currTNComparisonSections : [];
        const newGroup = await pricingActionsImport.savePricingGroup(
          skyboxId,
          groupData,
          false,
          comps,
          zones,
          typeListing,
          false,
          null,
          null,
          true
        );
        const groupId = newGroup?.response[0]?.id;
        await store.dispatch(refreshGroups(skyboxId));
        await store.dispatch(refreshGroupedListings(skyboxId));
        await store.dispatch(refreshInventory(skyboxId));
        store.dispatch(setGroupFocused(newGroup?.response[0]));
        pricingActions.setGroup(newGroup?.response[0]);
        pricingActions.setGroupEditingId(-1);
        if (newGroup?.response?.length) {
          pricingActions.setFocusedPricingGroupSection(groupId);
          if (groupsOpenned) {
            const newGroupsOppened = [...groupsOpenned];
            newGroupsOppened.push(groupId);
            store.dispatch(setGroupsOpenned(newGroupsOppened));
          }
        }
      }
      setState({ ...state, createGroupSaveButtonDisabled: false, isLoading: false, createGroupModalOpen: false });
    } catch (e) {
      setState({
        ...state,
        createGroupModalOpen: false,
      });
    }

    return false;
  };

  const addSelectedListingsToGroup = async event => {
    event.preventDefault();
    const { pricingActions, selectedInventoryRows, pricingGroup, skyboxId, zones, typeListing } = props;

    pricingActions.setGroupEditingId(pricingGroup.id);

    if (pricingGroup) {
      const ranks = selectedInventoryRows.map((row, index) => ({
        rank: index,
        skybox_listing_id: row.data.skybox_listing_id,
        include_exclude: pricingGroup.ranks.length ? pricingGroup.ranks[0].include_exclude : [],
      }));
      pricingGroup.ranks = [...pricingGroup.ranks, ...ranks];

      const comps = {};
      comps.ticketnetwork = pricingGroup.tnd_sections;
      comps.seatgeek = pricingGroup.sg_sections;

      await pricingActionsImport.savePricingGroup(
        skyboxId,
        [pricingGroup],
        false,
        comps,
        zones,
        typeListing,
        false,
        null,
        null,
        true
      );
      store.dispatch(refreshGroupedListings(skyboxId));
      await store.dispatch(refreshGroups(skyboxId));
      store.dispatch(refreshInventory(skyboxId));
    }

    setState({
      addListingsModalOpen: false,
    });
    pricingActions.setGroupEditingId(-1);
  };

  const createGroupCancelButtonClicked = () => {
    setState({
      ...state,
      createGroupModalOpen: false,
    });
  };

  const addListingsCancelButtonClicked = () => {
    setState({
      ...state,
      addListingsModalOpen: false,
    });
  };

  /*
   * Manage the tab selected
   * @param {object} event object
   * @param {string} value of the selected tab
   */
  const handleTabsChange = (event, value) => {
    const { refreshInteractiveGraphs } = props;
    setState({
      ...state,
      tabSelected: value,
      mountUngroupedListings: !value ? true : state.mountUngroupedListings,
    });

    if (value === TABS.HELD_OVER_TIME) {
      refreshInteractiveGraphs();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleHitEnter, true);

    return () => document.removeEventListener('keydown', handleHitEnter, true);
  }, []);

  const { inventoryRows, createGroupButtonDisabled, eventId, eventMeta, interactiveGraphs } = props;

  // eslint-disable-next-line camelcase
  const isAbTest = eventMeta.is_ab_test;
  const {
    createGroupModalOpen,
    addListingsModalOpen,
    currGroupName,
    createGroupSaveButtonDisabled,
    direction,
    tabSelected,
    mountUngroupedListings,
    isLoading,
  } = state;
  const transitionDuration = {
    enter: theme.transitions.duration.shortest,
    exit: theme.transitions.duration.leavingScreen,
  };
  const tabClasses = { root: theme.palette.type === 'light' ? classes.tab : classes.tabDark };

  useEffect(() => {
    if (!inventoryRows.length && tabSelected === TABS.UNGROUPED) {
      setState({ ...state, tabSelected: isAbTest ? TABS.TABLEAU : TABS.HELD_OVER_TIME });
    } else {
      setState({ ...state, mountUngroupedListings: true, tabSelected: tabSelected || TABS.UNGROUPED });
    }
  }, [inventoryRows]);

  const { groups } = props;
  const kobeZones = groups.reduce((acc, group) => {
    const isLvOv = group.name.includes('LV/OV');
    const words = group.name.trim().split(/\s+/);
    const currentZone = words.find(word => !/^[-+]/.test(word));
    const zoneName = isLvOv ? `${currentZone} LV/OV` : currentZone;
    if (currentZone && !acc.includes(zoneName)) {
      acc.push(zoneName);
    }
    return acc;
  }, []);

  return (
    <Box position="relative">
      <Card>
        <Card.Header variant="noPadding">
          <Tabs
            value={(() => {
              if (typeof tabSelected === 'undefined') {
                setState({ ...state, mountUngroupedListings: true, tabSelected: TABS.UNGROUPED });
                return TABS.UNGROUPED;
              }
              return tabSelected;
            })()}
            onChange={handleTabsChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            classes={{ root: classes.tabRoot }}
          >
            <Tab
              classes={tabClasses}
              label={<span className={classes.tabLabel}>{TABS.UNGROUPED}</span>}
              value={TABS.UNGROUPED}
              icon={
                <Avatar className={classes.inventoryTab}>
                  <Workspaces style={{ fontSize: 18 }} />
                </Avatar>
              }
              disabled={!inventoryRows.length}
            />
            {!isAbTest && (
              <Tab
                classes={tabClasses}
                label={<span className={classes.tabLabel}>{TABS.HELD_OVER_TIME}</span>}
                value={TABS.HELD_OVER_TIME}
                icon={
                  <Avatar className={classes.inventoryTab}>
                    <Timeline style={{ fontSize: 18 }} />
                  </Avatar>
                }
                disabled={!interactiveGraphs?.graphData?.lines?.length}
              />
            )}
            <Tab
              classes={tabClasses}
              label={<span className={classes.tabLabel}>{TABS.TABLEAU}</span>}
              value={TABS.TABLEAU}
              icon={
                <Avatar className={classes.inventoryTab}>
                  <Assessment style={{ fontSize: 18 }} />
                </Avatar>
              }
            />
            {showAutomationTab && (
              <Tab
                classes={tabClasses}
                label={<span className={classes.tabLabel}>{TABS.AUTOMATION}</span>}
                value={TABS.AUTOMATION}
                icon={
                  <Avatar classes={{ root: classes.inventoryTab }}>
                    <Settings style={{ fontSize: 18 }} />
                  </Avatar>
                }
              />
            )}
          </Tabs>
        </Card.Header>

        {tabSelected === TABS.UNGROUPED && mountUngroupedListings && (
          <div className={classes.inventoryTabsWrap}>
            <UngroupedListings
              classes={classes}
              transitionDuration={transitionDuration}
              createGroupButtonDisabled={createGroupButtonDisabled}
              direction={direction}
              isAbTest={isAbTest}
              inventoryRows={inventoryRows}
              // detailCellRendererParams={detailCellRendererParams}
              createGroupButtonClicked={createGroupButtonClicked}
              onSelectionChanged={onSelectionChanged}
              addListingsButtonClicked={addListingsButtonClicked}
              theme={theme}
            />
          </div>
        )}

        {!isAbTest && tabSelected === TABS.HELD_OVER_TIME && (
          <div className={classes.inventoryTabsWrap}>
            <SingleInteractiveGraph graphData={interactiveGraphs?.graphData} />
          </div>
        )}

        {tabSelected === TABS.TABLEAU && (
          <div className={classes.tableauTabsWrap} style={{ overflow: 'visible', paddingBottom: '75px' }}>
            <TableauTab eventId={eventId} />
          </div>
        )}

        {showAutomationTab && tabSelected === TABS.AUTOMATION && (
          <div className={clsx(classes.inventoryTabsWrap, classes.automationTabContainer)}>
            <Card.Content>
              <AutomationTab lobsangEventId={Number(eventId)} kobeZones={kobeZones.sort()} />
            </Card.Content>
          </div>
        )}

        <Modal
          aria-labelledby="Add listings to group"
          aria-describedby="Modal for add listings to group"
          open={addListingsModalOpen}
          data-testid="add-listings-group-modal"
        >
          <CreateGroupModal className={classes.pricingLoadingModalPaper}>
            <Typography variant="h6" id="modal-title">
              Would you like add selected listings to selected group?
            </Typography>
            <form autoComplete="off" onSubmit={addSelectedListingsToGroup}>
              <div className={classes.createGroupButtonWrap}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={addSelectedListingsToGroup}
                  style={{ width: '100%' }}
                  data-testid="confirm-add-listings-button"
                >
                  Yes
                </Button>
                <Button
                  variant="contained"
                  onClick={addListingsCancelButtonClicked}
                  style={{ width: '100%', marginTop: '10px' }}
                >
                  No
                </Button>
              </div>
            </form>
          </CreateGroupModal>
        </Modal>
        <NewGroupModal
          isModalOpen={createGroupModalOpen}
          createGroupSaveButtonClicked={createGroupSaveButtonClicked}
          createGroupNameInputChanged={createGroupNameInputChanged}
          createGroupSaveButtonDisabled={createGroupSaveButtonDisabled}
          createGroupCancelButtonClicked={createGroupCancelButtonClicked}
          currGroupName={currGroupName}
          isLoading={isLoading}
        />
      </Card>
    </Box>
  );
}

Inventory.propTypes = {
  eventId: PropTypes.string.isRequired,
  eventMeta: PropTypes.object.isRequired,
  inventoryRows: PropTypes.array.isRequired,
  pricingActions: PropTypes.object.isRequired,
  createGroupButtonDisabled: PropTypes.bool.isRequired,
  selectedInventoryRows: PropTypes.array.isRequired,
  skyboxId: PropTypes.number.isRequired,
  interactiveGraphs: PropTypes.object.isRequired,
  zones: PropTypes.array.isRequired,
  refreshInteractiveGraphs: PropTypes.func.isRequired,
  typeListing: PropTypes.string.isRequired,
  currTNComparisonSections: PropTypes.array.isRequired,
  pricingGroup: PropTypes.object.isRequired,
  groupsOpenned: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired,
};

function mapStateToProps(state) {
  return {
    createGroupButtonDisabled: state.pricing.ui.buttons.createGroupButtonDisabled,
    selectedInventoryRows: state.pricing.selectedInventoryRows,
    errorMessage: state.errorHandler.message,
    zones: state.zones,
    currTNComparisonSections: state.pricing.currTNComparisonSections,
    typeListing: state.pricing.focusedPricingGroupMarketplace,
    pricingGroup: state.pricing.selectedGroup,
    skyboxId: state.pricing.eventMeta.skybox_id,
    groupsOpenned: state.refreshGroupsInventory.groupsOpenned,
    groups: state.refreshGroups.groups,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    pricingActions: bindActionCreators(pricingActionsImport, dispatch),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Inventory);
